// extracted by mini-css-extract-plugin
export default {"Container":"IconButton_Container__jVEOe","ContainerSmall":"IconButton_ContainerSmall__156Yo","Icon":"IconButton_Icon__lygeX"};